import {InformationPropertyCard} from "./InformationPropertyCard.tsx";
import {
    Container,
    Grid,
    Stack
} from "@mantine/core";
import {ProductComponent} from "./ProductComponent.tsx";
import {MetadataPropertyCard} from "./MetadataPropertyCard.tsx";
import {BillingProviderManagement} from "./BillingProviderManagement.tsx";
import {Product} from "../types.ts";
import {IndexPage as PricesPage} from "../../prices/pages/IndexPage.tsx";
import {IndexPage as LineItemsPage} from "../../product-line-items/pages/IndexPage.tsx";
import {
    TabbedComponent,
    TabComponentTab
} from "@flexinet/ui-components";
import {useState} from 'react';


export const Profile = ({
                            record,
                            onRecordUpdate
                        }: { record: Product, onRecordUpdate?: (product: Product) => void }) => {
    const [currentProduct, setCurrentProduct] = useState(record);

    useState(() => {
        setCurrentProduct(record);
    });

    const handleProductUpdate = (updatedProduct: Product) => {
        setCurrentProduct(updatedProduct);
        if (onRecordUpdate) {
            onRecordUpdate(updatedProduct);
        }
    };

    const tabs = [
        {
            title: 'Prices',
            component: <PricesPage productId={record.id}/>,
        },
        {
            title: 'Line Items',
            component: <LineItemsPage/>
        },
        {
            title: 'Billing Provider',
            component: <BillingProviderManagement product={currentProduct} onProductUpdate={handleProductUpdate}/>
        },
        {
            title: 'Preview',
            component: <Container><ProductComponent product={currentProduct}/></Container>
        },
    ] as TabComponentTab[];


    return (

        <Grid>
            <Grid.Col span={{
                base: 12,
                lg: 4
            }}>
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={record}/>
                    <MetadataPropertyCard record={record}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{
                base: 12,
                lg: 8
            }}>
                <TabbedComponent tabs={tabs}/>
            </Grid.Col>
        </Grid>

    );


};
